import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { AppNavigationService } from "../core/navigation/app-navigation.service";
import { IAppSearchService } from "../@theme/shared/components/app-search/app-search.service";
import { SearchResult, SearchResultModel } from "../@theme/shared/components/app-search/app-search.models";

@Injectable({
  providedIn: 'root'
})
export class CareersAppSearchService implements IAppSearchService {
  constructor(private _http: HttpClient, @Inject('API_URL') private _apiUrl: string, private _navigation: AppNavigationService) {}

  public search(searchText: string): Observable<SearchResult[]>{
    let url: string = `${this._apiUrl}/admin/search`;

    let params = {
      'searchText': searchText
    }

    return this._http.post<SearchResult[]>(url, params).pipe(
      tap((res: SearchResult[]) => {
        res.forEach((r: SearchResult) => {
          r.icon = this.getSearchResultIcon(r.model);
        });
      })
    );
  }

  public redirectTo(searchResult: SearchResult): void {
    switch(searchResult.model){
      case SearchResultModel.candidate:
        this._navigation.goToCandidateProfile(searchResult.modelId);
        break;
      case SearchResultModel.requisition:
        this._navigation.goToEditJobRequisition(searchResult.modelId);
        break;
    }
  }

  /**
   * Get model icon to display in result list
   * @param type
   * @returns
   */
  private getSearchResultIcon(type: SearchResultModel): string {
    let icon = '';

    switch(type){
      case SearchResultModel.candidate:
        icon = 'account_circle';
        break;
      case SearchResultModel.requisition:
        icon = 'work';
        break;
      default:
        icon = 'east';
        break;
    }

    return icon;
  }
}
